import React from 'react';
import { useNavigate } from 'react-router-dom';

function CtaButton({ buttonText, subText }) {
  const navigate = useNavigate();
  return (
    <div className="text-center">
      <button 
      onClick={()=>navigate("/signup")}
        className="
          bg-gradient-to-b from-blue-400 to-blue-500 
          text-white font-bold text-lg 
          py-4 px-12 rounded-lg 
          shadow-lg shadow-blue-500/40
          transition-all duration-300 transform 
          hover:scale-105 hover:shadow-2xl 
          hover:from-cyan-400 hover:to-cyan-500 
          focus:outline-none focus:ring-4 focus:ring-cyan-300"
      >
        {buttonText}
      </button>
      {subText && (
        <p className="mt-4 text-sm text-slate-500">
          {subText}
        </p>
      )}
    </div>
  );
}

export default CtaButton;